import Request from './Request'

export default Request
